import React from 'react'; 
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Schema from './schema'; 
import Generatehtaccessfile from './generatehtaccessfile';
import NoPage from './noPage';
 
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/seo-tools/schema-markup-generator" element={<Schema />}> 
        </Route>
        {/* <Route path="/seo-tool/*" element={<NoPage />} /> */}
        <Route exact path="/seo-tools/htaccess-generator" element={<Generatehtaccessfile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App